/* eslint-disable react-hooks/exhaustive-deps */
import clsx from "clsx";
import { FC, useEffect, useState } from "react";
import SignalBarIcon from "@ht/shared/fonts/deos-pis/signal-bar";

interface IProps {
    ping: string;
    threshold1: number;
    threshold2: number;
}

const SignalIndicator: FC<IProps> = ({ ping, threshold1, threshold2 }) => {
    const [signal, setSignal] = useState("good");
    const [tooltip, setTooltip] = useState("");

    useEffect(() => {
        if (Number(ping) > 10000) {
            setSignal("disconnected");
            setTooltip("You are disconnected from video/audio service");
        } else if (Number(ping) > threshold1) {
            setSignal("warning");
            setTooltip(
                "Your connection is slowing, it might affect your call quality"
            );
        } else if (Number(ping) > threshold2) {
            setSignal("danger");
            setTooltip(
                "Your connection is slow, try changing to other networks"
            );
        } else {
            setSignal("good");
            setTooltip("You have good connection");
        }
    }, [ping]);

    return (
        <div className="h-[16px] md:flex flex-row items-center hidden ">
            <div
                className={clsx(
                    "mr-2 w-[12px] h-[12px] ",
                    { "text-success": signal === "good" },
                    { "text-warning": signal === "warning" },
                    { "text-danger": signal === "danger" },
                    { "text-black": signal === "disconnect" }
                )}
                title={tooltip}
            >
                <SignalBarIcon />
            </div>
            <div className="text-gray-900 font-semibold text-sm">{ping} ms</div>
        </div>
    );
};

export default SignalIndicator;
